import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["data", "getItemProps", "title", "hasRecentSearchTerms"];

var _templateObject;

import React, { forwardRef } from "react";
import { Box, Flex, Highlighter, IconSearch, List, ListItem, Span, TrendingUpIcon } from "@catchoftheday/cg-components";
import { styled, themeGet } from "@catchoftheday/theme";
import { SEARCH_TRENDING_TERM_POD_ID } from "../../../../consts";
import { SearchBarHeader } from "../../../layouts/SearchBar/SearchBarLayouts";
import { jsx as ___EmotionJSX } from "@emotion/react";
var MOBILE_MAX_VISIBLE_TERMS = 5;
var SearchItemContainer = styled(ListItem)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:hover,\n  &[aria-selected=\"true\"] {\n    color: ", ";\n    text-decoration: underline;\n    cursor: pointer;\n  }\n"])), themeGet("colors.typography.link"));

function mapSearchIcon(itemData) {
  if ("podId" in itemData && itemData.podId === SEARCH_TRENDING_TERM_POD_ID) {
    return ___EmotionJSX(TrendingUpIcon, {
      style: {
        width: "15px",
        marginRight: "8px"
      }
    });
  }

  return ___EmotionJSX(IconSearch, {
    width: "12px",
    mr: 2
  });
}

export var SearchSuggestions = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var data = _ref.data,
      getItemProps = _ref.getItemProps,
      title = _ref.title,
      hasRecentSearchTerms = _ref.hasRecentSearchTerms,
      props = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(Box, {
    flex: 1
  }, ___EmotionJSX(SearchBarHeader, null, title), ___EmotionJSX(List, _extends({
    type: "none",
    role: "listbox",
    mt: "16px",
    "data-cnstrc-item-section": title,
    ref: ref
  }, props), data.map(function (itemData, idx) {
    return ___EmotionJSX(SearchItemContainer, _extends({
      mb: "6px",
      key: idx,
      display: {
        xs: idx >= MOBILE_MAX_VISIBLE_TERMS ? "none" : "list-item",
        md: "list-item"
      },
      "data-cnstrc-item-name": itemData.title,
      "data-cnstrc-item-group": itemData.groupId
    }, getItemProps(itemData)), ___EmotionJSX(Flex, {
      alignItems: "center"
    }, mapSearchIcon(itemData), ___EmotionJSX(Box, {
      flex: 1
    }, itemData.matched_terms.length > 0 ? ___EmotionJSX(Highlighter, {
      highlight: itemData.matched_terms[0] //TODO: Should we update Highlighter to accept an array of matched terms?
      ,
      text: itemData.value,
      reverse: true,
      highlightTextProps: {
        fontSize: "14px"
      },
      textProps: {
        fontSize: "14px"
      }
    }) : ___EmotionJSX(Span, null, itemData.value), itemData.groupName && ___EmotionJSX(Span, {
      color: "brand.primary"
    }, " in ", itemData.groupName))));
  })));
});
SearchSuggestions.displayName = "SearchSuggestions";